import { EventRecord, LogGroup } from '@react-admin/ra-audit-log';
import { format } from 'date-fns';

const sortByDate = (a: EventRecord, b: EventRecord): number =>
  new Date(b.date).valueOf() - new Date(a.date).valueOf();

const getDayForAuditLog = (record: EventRecord): string => {
  const date = new Date(record.date);
  /* eslint-disable @sh4res/ban-date-mutation -- no equal function in date-fns */
  date.setUTCMilliseconds(0);
  date.setUTCSeconds(0);
  date.setUTCMinutes(0);
  date.setUTCHours(0);
  /* eslint-enable @sh4res/ban-date-mutation */
  return date.toISOString();
};

const getDayString = (value: string) => `• ${format(new Date(value), 'd MMM, yyyy')}`;

/**
 * identical to groupByDay from react-admin, but renders the label with different format
 */
export const groupLogsWithUTCLabel = (records: EventRecord[]): LogGroup[] => {
  const initialMap: Record<string, EventRecord[] | undefined> = {};

  const map = records.reduce((acc, record) => {
    const label = getDayString(getDayForAuditLog(record));
    acc[label] = (acc[label] ?? []).concat(record);
    return acc;
  }, initialMap);

  return Object.entries(map).reduce((acc, [label, groupedRecords]) => {
    acc.push({ label, records: (groupedRecords ?? []).sort(sortByDate) });
    return acc;
  }, [] as LogGroup[]);
};
